import $ from './lib/jquery';
window.bootstrap = require('bootstrap/dist/js/bootstrap.bundle.js')
import TraversableMenu from 'traversable_menu';
import 'magnific-popup/dist/jquery.magnific-popup';
import 'leaflet';
import Swiper from 'swiper/swiper-bundle';
// import Masonry from 'masonry-layout';
var jQueryBridget = require('jquery-bridget/jquery-bridget');
var Masonry = require( 'masonry-layout' );
// make Masonry a jQuery plugin
jQueryBridget( 'masonry', Masonry, $ );

$( document ).ready(function() {

    /**
     * Name           : SkipLinks
     * Beschreibung   : Open Navigation on click on skip link
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery
     */
    function focusFirstNavLink() {
        console.log("firstnavlink function triggered");
        setTimeout(function() {
            $('.sidebar').addClass('opened'); // Öffnet die Sidebar mit Verzögerung
            $('.navigation-layer .navigation-header a').first().focus(); // Fokussiert den ersten Link
        }, 100); // Verzögerung von 100 Millisekunden
    }
    // Event-Handler für Klick- und Tastaturereignisse auf dem Skiplink
    $('#skiplink-main-menu').on('click keydown', function(event) {
        event.preventDefault(); // Verhindert das Standardverhalten des Links
        console.log("Event type: " + event.type); // Ausgabe des Event-Typs
        if (event.type === 'click') {
            console.log("Skiplink clicked");
            focusFirstNavLink();
        }
        if (event.type === 'keydown' && event.key === 'Enter') {
            focusFirstNavLink();
        }
    });



    /**
     * Name           : Navigation
     * Beschreibung   : .
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery
     */

    $('.hamburger, .navi-button').on('click', function () {
        $('.sidebar').toggleClass('opened');
        $('[data-main]').toggleClass('hasVisibleSidebar');
        $('html').toggleClass('noscroll');
    });

    $('.hamburger, .navi-button').keypress(function (e) {
        var key = e.which;
        if (key == 13)  // the enter key code
        {
            $('.sidebar').toggleClass('opened');
            $('[data-main]').toggleClass('hasVisibleSidebar');
            $('html').toggleClass('noscroll');
            $('#traversable_menu_panel_1_0_0').focus();
        }
    });

//Close menu if click outside of navbar
    $(window).click(function () {
        $('.sidebar').removeClass('opened');
        $('[data-main]').removeClass('hasVisibleSidebar');
        $('html').removeClass('noscroll');
    });
    $('.navbar-toggler, .sidebar').click(function (event) {
        event.stopPropagation();
    });

    var traversable = new TraversableMenu(
        {
            //'panel_title_first': 'Traversable Menu Example'
            // many additional options here; see below
            triggers: {
                'parent_text': 'Zu [:previous-title:]',
                'top_text': 'Zum Hauptmenü',
            },
            // accessibility: {
            //     'container_role': 'navigation',
            //     'panel_role': 'group',
            // },
            'panel_title_link_enabled': true,
        }
    );
// traversable.initializeFromHTML("#primary-menu");

    /**
     * Name           : Offset für Jumplist-Navigation (A-Z)
     * Beschreibung   : .
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : -
     */
    const offset = 120; // Definiere den Offset-Wert, der von der Oberkante abgezogen werden soll.

    document.querySelectorAll('.az-jumplist a').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            // Scrollen zu dem Ziel unter Berücksichtigung des Offsets.
            const target = document.querySelector(this.getAttribute('href'));
            const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
            const offsetPosition = elementPosition - offset;
            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });
        });
    });

    /* Stage-Gallery */
    const stagegallery = new Swiper('.stage-gallery', {
        // Optional parameters
        loop: true,
        speed: 1000,
        effect: "slide",
        autoplay: {
            delay: 5000,
        },
        centeredSlides: true,
        slidesPerView: '1',
        // If we need pagination
        pagination: {
            el: '.swiper-pagination',
            clickable: false,
        },

        // Navigation arrows
        // navigation: {
        //     nextEl: '.swiper-next',
        //     prevEl: '.swiper-prev',
        // },
    });
    $(".swiper-button-pause").click(function(){
        stagegallery.autoplay.stop();
        $('.stage-gallery').toggleClass('paused')
    });

    $(".swiper-button-play").click(function(){
        stagegallery.autoplay.start();
        $('.stage-gallery').toggleClass('paused')
    });





    /**
     * Name           : Job - Filter
     * Beschreibung   : .
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery
     */
    const filterForm = document.getElementById('jobs-filter');

    if (filterForm) {
        const locationFilter = filterForm.querySelector('select[name="jobs-location"]');
        const profileFilter = filterForm.querySelector('select[name="jobs-profile"]');
        const jobCards = document.querySelectorAll('.msnry .job-item');
        const msnry = document.querySelector('.msnry');
        const noResultsMessage = document.querySelector('.no-results');
        const resetButton = document.getElementById('reset-filters');

        if (msnry) {
            const masonryInstance = new Masonry(msnry, {
                itemSelector: '.job-item',
                columnWidth: '.grid-sizer',
                percentPosition: true
            });

            function filterJobs() {
                const selectedLocation = locationFilter.value;
                const selectedProfile = profileFilter.value;

                let visibleCount = 0;  // Zähler für sichtbare Karten

                jobCards.forEach(card => {
                    const cardLocation = card.getAttribute('data-location');
                    const cardProfile = card.getAttribute('data-profile');

                    // Prüfen, ob die ausgewählte Location in den Karten-Standorten enthalten ist
                    let locationMatch = selectedLocation === "" ||
                        cardLocation.split(',').map(loc => loc.trim()).includes(selectedLocation);
                    let profileMatch = selectedProfile === "" || cardProfile === selectedProfile;

                    if (locationMatch && profileMatch) {
                        card.style.display = "block";
                        visibleCount++;
                    } else {
                        card.style.display = "none";
                    }
                });

                // Wenn keine Karten sichtbar sind, zeige die "Keine Treffer"-Nachricht
                if (visibleCount === 0) {
                    noResultsMessage.style.display = "block";
                } else {
                    noResultsMessage.style.display = "none";
                }


                // Nach der Filterung Masonry erneut layouten
                masonryInstance.layout();
            }

            locationFilter.addEventListener('change', filterJobs);
            profileFilter.addEventListener('change', filterJobs);

            // Funktion für das Zurücksetzen der Filter
            resetButton.addEventListener('click', function () {
                // Setze die Filter zurück
                locationFilter.value = "";
                profileFilter.value = "";

                // Zeige alle Karten wieder an
                jobCards.forEach(card => {
                    card.style.display = "block";
                });

                // Verstecke die "Keine Treffer"-Nachricht
                noResultsMessage.style.display = "none";

                // Masonry-Layout nach dem Zurücksetzen neu laden
                masonryInstance.layout();
            });
        }
    }




    /**
     * Name           : Kartendarstellung - Openstreet-Map
     * Beschreibung   : .
     * Parameter      : -
     * Rückgabe       : -
     * Bibliothek     : jQuery, leaflet, openstreetmap
     */

    // // Standardkoordinaten für Offenbach am Main
    // var defaultCoordinates = [50.095636, 8.776085];
    // var defaultZoom = 13;
    //
    // // Initialisiere die Karte und zentriere standardmäßig auf Offenbach
    // var map = L.map('map').setView(defaultCoordinates, defaultZoom);
    //
    // // Füge die OpenStreetMap-Tiles hinzu
    // L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    //     attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    // }).addTo(map);
    //
    // // Definiere das benutzerdefinierte Icon
    // var customIcon = L.icon({
    //     iconUrl: '/assets/global/img/marker.png',  // URL des Icons
    //     iconSize: [39, 33],  // Größe des Icons in Pixeln
    //     iconAnchor: [0, 33],  // Die Koordinaten des Icons (wo es verankert ist)
    //     popupAnchor: [0, -38]  // Die Position des Popups relativ zum Icon
    // });
    //
    // // Initialisiere eine Bounds-Instanz, um später alle Marker-Koordinaten hinzuzufügen
    // var bounds = L.latLngBounds();
    //
    // // Lese die Adressen aus dem data-addresses Attribut
    // var mapDataElement = document.getElementById('map-data');
    // var addresses = mapDataElement ? JSON.parse(mapDataElement.getAttribute('data-addresses')) : [];
    //
    // // Funktion zur Geokodierung von Adressen
    // function geocodeAddress(address, popupText) {
    //     var url = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(address)}`;
    //     fetch(url)
    //         .then(response => response.json())
    //         .then(data => {
    //             if (data && data.length > 0) {
    //                 var lat = data[0].lat;
    //                 var lon = data[0].lon;
    //                 // Marker mit benutzerdefiniertem Icon hinzufügen
    //                 var marker = L.marker([lat, lon], { icon: customIcon }).addTo(map)
    //                     .bindPopup(popupText);
    //                 // Marker-Koordinaten zu den Bounds hinzufügen
    //                 bounds.extend([lat, lon]);
    //                 // Karte anpassen, sodass alle Marker sichtbar sind
    //                 map.fitBounds(bounds);
    //             } else {
    //                 console.log('Adresse nicht gefunden:', address);
    //             }
    //         })
    //         .catch(err => console.error('Fehler bei der Geokodierung:', err));
    // }
    //
    // // Überprüfen, ob Adressen vorhanden sind
    // if (addresses.length > 0) {
    //     // Iteriere über die Adressen und setze Marker
    //     addresses.forEach(function(item) {
    //         geocodeAddress(item.address, item.popupText);
    //     });
    // } else {
    //     // Wenn keine Adressen vorhanden sind, zentriere die Karte auf Offenbach
    //     map.setView(defaultCoordinates, defaultZoom);
    // }

});